import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { PixKeyType } from '../../models/key-type.enum';
import { Util } from '../../../../utils/util';
import { PixGenerateQrCode } from '../../models/generate-qrcode.model';
import { PixQrCode } from '../../models/qr-code.model';
import { PixKeysService } from '../../keys/keys.service';

@Component({
	selector: 'app-pix-receive-payment-simple',
	templateUrl: './simple.component.html',
	styleUrls: ['./simple.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixReceivePaymentSimpleComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public minDate = new Date(new Date());
	public maxDate = new Date(new Date().setMonth(new Date().getMonth() + 1));
	public pixGenerateQrCode: PixGenerateQrCode;

	constructor(
		private formBuilder: FormBuilder,
		private router: Router,
		public dialog: MatDialog,
		private pixKeysService: PixKeysService,
	) { }

	ngOnInit(): void {
		this.pixGenerateQrCode = this.pixKeysService.getPixGenerateQrCode();
		this.checkParams() ? this.goBack() : '';
		this.buildForm();
	}

	checkParams(): boolean {
		return this.pixGenerateQrCode === undefined || this.pixGenerateQrCode.codigo === undefined || this.pixGenerateQrCode.tipoChave === undefined
	}

	buildForm() {
		this.form = this.formBuilder.group({
			key: this.getCodeWithMask(),
			value: ['', Validators.max(999999999)], // Validators.min(1), Validators.max(9999.00)
			description: ['', [Validators.pattern(Util.allowedCharactersRegex), Validators.maxLength(100)]],
			identification: ['']
		});
	}

	getCodeWithMask() {
		if (!this.checkParams()) {
			switch (this.pixGenerateQrCode.tipoChave) {
				case PixKeyType.CPF:
					return Util.maskCpfCnpj(this.pixGenerateQrCode.codigo);
				case PixKeyType.CNPJ:
					return Util.maskCpfCnpj(this.pixGenerateQrCode.codigo);
				case PixKeyType.PHONE:
					return Util.formatPhone(this.pixGenerateQrCode.codigo);
				default:
					return this.pixGenerateQrCode.codigo;
			}
		}
	}

	submit() {
		if (this.form.valid) {
			this.getQrCode();
		}
	}

	getQrCode() {
		const request = new PixGenerateQrCode(
			this.pixGenerateQrCode.codigo,
			this.pixGenerateQrCode.tipoChave,
			this.form.get('description').value,
			'D',
			this.form.get('identification').value,
			'ESTATICO',
			+this.form.get('value').value
		);

		this.pixKeysService.getQrCode(request).subscribe(data => {
			if (data.Existe && data.Sucesso) {
				this.pixKeysService.setPixQrCode(Util.keysToCamel(data.Retorno) as PixQrCode);
				this.pixKeysService.setPixGenerateQrCode(request);
				this.goNext();
			}
		});
	}

	verifyZero() {
		if ($('.currency-field').val() === '0,00') {
			$('.currency-field').val('');
		}
	}

	goNext = () => this.router.navigate(['pix/receber/qr-code']);
	goBack = () => this.router.navigate(['pix/receber']);

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/receive-payment/simple/simple.component.ts